export default "__VITE_ASSET__oOMx1Mm7__"